/* eslint-disable sort-keys -- keep route keys in a readable order (path-first) */

import { Fragment } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import ScrollToTop from '../../../components/ScrollToTop/ScrollToTop';
import CmsGuard from '../../../guards/CmsGuard/CmsGuard';
import ErrorReportingGuard from '../../../guards/ErrorReportingGuard/ErrorReportingGuard';
import LoanDocumentGuard from '../../../guards/LoanDocumentGuard/LoanDocumentGuard';
import RouteChangeGuard from '../../../guards/RouteChangeGuard/RouteChangeGuard';
import SessionGuard from '../../../guards/SessionGuard/SessionGuard';
import StorageGuard from '../../../guards/StorageGuard/StorageGuard';
import WorkflowGuard from '../../../guards/WorkflowGuard/WorkflowGuard';
import { Component as ActivationPage } from '../../../pages/ActivationPage/ActivationPage';
import { Component as ActivationPinVerifyPage } from '../../../pages/ActivationPinVerifyPage/ActivationPinVerifyPage';
import { Component as ApplicantAddCoapplicantPage } from '../../../pages/Applicant/ApplicantAddCoapplicantPage/ApplicantAddCoapplicantPage';
import { Component as ApplicantAdditionalIncomePage } from '../../../pages/Applicant/ApplicantAdditionalIncomePage/ApplicantAdditionalIncomePage';
import { Component as ApplicantEditEmploymentPage } from '../../../pages/Applicant/ApplicantEditEmploymentPage/ApplicantEditEmploymentPage';
import { Component as ApplicantEditIncomePage } from '../../../pages/Applicant/ApplicantEditIncomePage/ApplicantEditIncomePage';
import { Component as ApplicantEditPersonalPage } from '../../../pages/Applicant/ApplicantEditPersonalPage/ApplicantEditPersonalPage';
import { Component as ApplicantEditResidencePage } from '../../../pages/Applicant/ApplicantEditResidencePage/ApplicantEditResidencePage';
import { Component as ApplicantEmploymentDetailsPage } from '../../../pages/Applicant/ApplicantEmploymentDetailsPage/ApplicantEmploymentDetailsPage';
import { Component as ApplicantEmploymentDurationPage } from '../../../pages/Applicant/ApplicantEmploymentDurationPage/ApplicantEmploymentDurationPage';
import { Component as ApplicantEmploymentStatusPage } from '../../../pages/Applicant/ApplicantEmploymentStatusPage/ApplicantEmploymentStatusPage';
import { Component as ApplicantEmploymentTypePage } from '../../../pages/Applicant/ApplicantEmploymentTypePage/ApplicantEmploymentTypePage';
import { Component as ApplicantIncomeDetailsPage } from '../../../pages/Applicant/ApplicantIncomeDetailsPage/ApplicantIncomeDetailsPage';
import { Component as ApplicantPage } from '../../../pages/Applicant/ApplicantPage/ApplicantPage';
import { Component as ApplicantPreviousEmploymentPage } from '../../../pages/Applicant/ApplicantPreviousEmploymentPage/ApplicantPreviousEmploymentPage';
import { Component as ApplicantPreviousResidencePage } from '../../../pages/Applicant/ApplicantPreviousResidencePage/ApplicantPreviousResidencePage';
import { Component as ApplicantResidenceDetailsPage } from '../../../pages/Applicant/ApplicantResidenceDetailsPage/ApplicantResidenceDetailsPage';
import { Component as ApplicantResidenceDurationPage } from '../../../pages/Applicant/ApplicantResidenceDurationPage/ApplicantResidenceDurationPage';
import { Component as ApplicantResidenceTypePage } from '../../../pages/Applicant/ApplicantResidenceTypePage/ApplicantResidenceTypePage';
import { Component as ApplicantReviewPage } from '../../../pages/Applicant/ApplicantReviewPage/ApplicantReviewPage';
import { Component as ApplicantSubmitPage } from '../../../pages/Applicant/ApplicantSubmitPage/ApplicantSubmitPage';
import { Component as ApplicantSuccessPage } from '../../../pages/Applicant/ApplicantSuccessPage/ApplicantSuccessPage';
import { Component as ApplicantUnemploymentDetailsPage } from '../../../pages/Applicant/ApplicantUnemploymentDetailsPage/ApplicantUnemploymentDetailsPage';
import { Component as ApplicantUnemploymentTypePage } from '../../../pages/Applicant/ApplicantUnemploymentTypePage/ApplicantUnemploymentTypePage';
import { Component as ApplicationUpdatePage } from '../../../pages/ApplicationUpdatePage/ApplicationUpdatePage';
import { Component as ApplyApplicationTypePage } from '../../../pages/Apply/ApplyApplicationTypePage/ApplyApplicationTypePage';
import { Component as ApplyConfirmVehiclePage } from '../../../pages/Apply/ApplyConfirmVehiclePage/ApplyConfirmVehiclePage';
import { Component as ApplyPage } from '../../../pages/Apply/ApplyPage/ApplyPage';
import { Component as ApplyPurchaseTypePage } from '../../../pages/Apply/ApplyPurchaseTypePage/ApplyPurchaseTypePage';
import { Component as ApplyRefinanceGoalPage } from '../../../pages/Apply/ApplyRefinanceGoalPage/ApplyRefinanceGoalPage';
import { Component as ApplySearchMakePage } from '../../../pages/Apply/ApplySearchMakePage/ApplySearchMakePage';
import { Component as ApplySearchModelPage } from '../../../pages/Apply/ApplySearchModelPage/ApplySearchModelPage';
import { Component as ApplySearchPlatePage } from '../../../pages/Apply/ApplySearchPlatePage/ApplySearchPlatePage';
import { Component as ApplySearchVehiclePage } from '../../../pages/Apply/ApplySearchVehiclePage/ApplySearchVehiclePage';
import { Component as ApplySearchVinPage } from '../../../pages/Apply/ApplySearchVinPage/ApplySearchVinPage';
import { Component as ApplySearchYearPage } from '../../../pages/Apply/ApplySearchYearPage/ApplySearchYearPage';
import { Component as ApplyVehicleConditionPage } from '../../../pages/Apply/ApplyVehicleConditionPage/ApplyVehicleConditionPage';
import { Component as ApplyVehicleSelectionPage } from '../../../pages/Apply/ApplyVehicleSelectionPage/ApplyVehicleSelectionPage';
import { Component as CoapplicantAdditionalIncomePage } from '../../../pages/Coapplicant/CoapplicantAdditionalIncomePage/CoapplicantAdditionalIncomePage';
import { Component as CoapplicantDifferentResidencePage } from '../../../pages/Coapplicant/CoapplicantDifferentResidencePage/CoapplicantDifferentResidencePage';
import { Component as CoapplicantDifferentResidenceTypePage } from '../../../pages/Coapplicant/CoapplicantDifferentResidenceTypePage/CoapplicantDifferentResidenceTypePage';
import { Component as CoapplicantEditEmploymentPage } from '../../../pages/Coapplicant/CoapplicantEditEmploymentPage/CoapplicantEditEmploymentPage';
import { Component as CoapplicantEditIncomePage } from '../../../pages/Coapplicant/CoapplicantEditIncomePage/CoapplicantEditIncomePage';
import { Component as CoapplicantEditPersonalPage } from '../../../pages/Coapplicant/CoapplicantEditPersonalPage/CoapplicantEditPersonalPage';
import { Component as CoapplicantEditResidencePage } from '../../../pages/Coapplicant/CoapplicantEditResidencePage/CoapplicantEditResidencePage';
import { Component as CoapplicantEmploymentDetailsPage } from '../../../pages/Coapplicant/CoapplicantEmploymentDetailsPage/CoapplicantEmploymentDetailsPage';
import { Component as CoapplicantEmploymentDurationPage } from '../../../pages/Coapplicant/CoapplicantEmploymentDurationPage/CoapplicantEmploymentDurationPage';
import { Component as CoapplicantEmploymentStatusPage } from '../../../pages/Coapplicant/CoapplicantEmploymentStatusPage/CoapplicantEmploymentStatusPage';
import { Component as CoapplicantEmploymentTypePage } from '../../../pages/Coapplicant/CoapplicantEmploymentTypePage/CoapplicantEmploymentTypePage';
import { Component as CoapplicantIncomeDetailsPage } from '../../../pages/Coapplicant/CoapplicantIncomeDetailsPage/CoapplicantIncomeDetailsPage';
import { Component as CoapplicantPersonalDetailsPage } from '../../../pages/Coapplicant/CoapplicantPersonalDetailsPage/CoapplicantPersonalDetailsPage';
import { Component as CoapplicantPreviousEmploymentPage } from '../../../pages/Coapplicant/CoapplicantPreviousEmploymentPage/CoapplicantPreviousEmploymentPage';
import { Component as CoapplicantPreviousResidencePage } from '../../../pages/Coapplicant/CoapplicantPreviousResidencePage/CoapplicantPreviousResidencePage';
import { Component as CoapplicantRelationshipPage } from '../../../pages/Coapplicant/CoapplicantRelationshipPage/CoapplicantRelationshipPage';
import { Component as CoapplicantResidenceDurationPage } from '../../../pages/Coapplicant/CoapplicantResidenceDurationPage/CoapplicantResidenceDurationPage';
import { Component as CoapplicantResidenceRelationshipPage } from '../../../pages/Coapplicant/CoapplicantResidenceRelationshipPage/CoapplicantResidenceRelationshipPage';
import { Component as CoapplicantReviewPage } from '../../../pages/Coapplicant/CoapplicantReviewPage/CoapplicantReviewPage';
import { Component as CoapplicantSameResidencePage } from '../../../pages/Coapplicant/CoapplicantSameResidencePage/CoapplicantSameResidencePage';
import { Component as CoapplicantUnemploymentDetailsPage } from '../../../pages/Coapplicant/CoapplicantUnemploymentDetailsPage/CoapplicantUnemploymentDetailsPage';
import { Component as CoapplicantUnemploymentTypePage } from '../../../pages/Coapplicant/CoapplicantUnemploymentTypePage/CoapplicantUnemploymentTypePage';
import { Component as DashboardApplicationPage } from '../../../pages/DashboardApplicationPage/DashboardApplicationPage';
import { Component as DashboardGaragePage } from '../../../pages/DashboardGaragePage/DashboardGaragePage';
import { Component as LoanDocumentListPage } from '../../../pages/LoanDocument/LoanDocumentListPage/LoanDocumentListPage';
import { Component as LoanDocumentMileagePage } from '../../../pages/LoanDocument/LoanDocumentMileagePage/LoanDocumentMileagePage';
import { Component as LoanDocumentPage } from '../../../pages/LoanDocument/LoanDocumentPage/LoanDocumentPage';
import { Component as LoanDocumentSuccessPage } from '../../../pages/LoanDocument/LoanDocumentSuccessPage/LoanDocumentSuccessPage';
import { Component as LoanDocumentUploadAllPage } from '../../../pages/LoanDocument/LoanDocumentUploadAllPage/LoanDocumentUploadAllPage';
import { Component as LoanDocumentUploadGAPPage } from '../../../pages/LoanDocument/LoanDocumentUploadGAPPage/LoanDocumentUploadGAPPage';
import { Component as LoanDocumentUploadRICPage } from '../../../pages/LoanDocument/LoanDocumentUploadRICPage/LoanDocumentUploadRICPage';
import { Component as LoanDocumentUploadVSCPage } from '../../../pages/LoanDocument/LoanDocumentUploadVSCPage/LoanDocumentUploadVSCPage';
import { Component as MailCodeActivationPage } from '../../../pages/MailCode/MailCodeActivationPage/MailCodeActivationPage';
import { Component as MailCodeOfferPage } from '../../../pages/MailCode/MailCodeOfferPage/MailCodeOfferPage';
import { Component as MailCodePage } from '../../../pages/MailCode/MailCodePage/MailCodePage';
import { Component as MailCodePinVerifyPage } from '../../../pages/MailCode/MailCodePinVerifyPage/MailCodePinVerifyPage';
import { Component as NotFoundPage } from '../../../pages/NotFoundPage/NotFoundPage';
import { Component as PreviewActivationPage } from '../../../pages/Preview/PreviewActivationPage/PreviewActivationPage';
import { Component as PreviewOfferPage } from '../../../pages/Preview/PreviewOfferPage/PreviewOfferPage';
import { Component as PreviewPinVerifyPage } from '../../../pages/Preview/PreviewPinVerifyPage/PreviewPinVerifyPage';
import { Component as SignInPage } from '../../../pages/SignInPage/SignInPage';
import { Component as SignInPinVerifyPage } from '../../../pages/SignInPinVerifyPage/SignInPinVerifyPage';
import { Component as SignOutPage } from '../../../pages/SignOutPage/SignOutPage';
import { Component as SignUpPage } from '../../../pages/SignUpPage/SignUpPage';
import { Component as SignUpPinVerifyPage } from '../../../pages/SignUpPinVerifyPage/SignUpPinVerifyPage';
import { Component as SignUpReturningUserPage } from '../../../pages/SignUpReturningUserPage/SignUpReturningUserPage';
import { Component as VehicleConfirmationPage } from '../../../pages/VehicleConfirmationPage/VehicleConfirmationPage';
import { Component as VerificationDocumentListPage } from '../../../pages/Verifications/VerificationDocumentListPage/VerificationDocumentListPage';
import { Component as VerificationPage } from '../../../pages/Verifications/VerificationPage/VerificationPage';
import { Component as VerificationUploadPage } from '../../../pages/Verifications/VerificationUploadPage/VerificationUploadPage';
import useApplicantStore from '../../applicantStore/useApplicantStore';
import useApplyStore from '../../applyStore/useApplyStore';
import useDashboardStore from '../../dashboardStore/useDashboardStore';
import useVerificationStore from '../../verificationStore/useVerificationStore';

export const routes = [
  {
    path: '',
    element: (
      <ScrollToTop>
        <StorageGuard>
          <RouteChangeGuard>
            <ErrorReportingGuard>
              <Fragment>
                <Outlet />
              </Fragment>
            </ErrorReportingGuard>
          </RouteChangeGuard>
        </StorageGuard>
      </ScrollToTop>
    ),
    children: [
      {
        path: 'sign-in',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <SignInPage />,
          },
          {
            path: 'application-update',
            element: <ApplicationUpdatePage />,
          },
          {
            path: 'pin-verify',
            element: <SignInPinVerifyPage />,
          },
        ],
      },
      {
        path: 'sign-up',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <SignUpPage />,
          },
          {
            path: 'pin-verify',
            element: <SignUpPinVerifyPage />,
          },
          {
            path: 'returning-user',
            element: <SignUpReturningUserPage />,
          },
        ],
      },
      {
        path: 'sign-out',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <Outlet />
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <SignOutPage />,
          },
        ],
      },
      {
        path: 'mail',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <Outlet />
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <MailCodePage />,
          },
          {
            path: 'offer',
            element: <MailCodeOfferPage />,
          },
          {
            path: 'activation',
            element: <MailCodeActivationPage />,
          },
          {
            path: 'pin-verify',
            element: <MailCodePinVerifyPage />,
          },
        ],
      },
      {
        path: 'preview',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <Outlet />
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="offer" />,
          },
          {
            path: 'offer',
            element: <PreviewOfferPage />,
          },
          {
            path: 'activation',
            element: <PreviewActivationPage />,
          },
          {
            path: 'pin-verify',
            element: <PreviewPinVerifyPage />,
          },
        ],
      },
      {
        path: 'activation',
        isPublicRoute: true,
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <ActivationPage />,
          },
          {
            path: 'pin-verify',
            element: <ActivationPinVerifyPage />,
          },
        ],
      },
      {
        path: 'dashboard',
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard/garage" />,
          },
          {
            path: 'garage',
            element: <DashboardGaragePage />,
          },
          {
            path: 'application/:vehicleId',
            element: <DashboardApplicationPage />,
          },
        ],
      },
      {
        path: 'update-vehicle/:vehicleId',
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <VehicleConfirmationPage />,
          },
        ],
      },
      {
        path: 'apply',
        loader: (): Promise<Response | null> =>
          useApplyStore.getState().loader(),
        shouldRevalidate: ({ currentUrl, nextUrl }): boolean =>
          currentUrl.pathname !== nextUrl.pathname,
        element: (
          <WorkflowGuard>
            <CmsGuard>
              <SessionGuard>
                <Outlet />
              </SessionGuard>
            </CmsGuard>
          </WorkflowGuard>
        ),
        children: [
          {
            index: true,
            element: <ApplyPage />,
          },
          {
            path: 'application-type',
            element: <ApplyApplicationTypePage />,
          },
          {
            path: 'refinance-goal',
            element: <ApplyRefinanceGoalPage />,
          },
          {
            path: 'purchase-type',
            element: <ApplyPurchaseTypePage />,
          },
          {
            path: 'vehicle-condition',
            element: <ApplyVehicleConditionPage />,
          },
          {
            path: 'vehicle-selection',
            element: <ApplyVehicleSelectionPage />,
          },
          {
            path: 'search-vehicle',
            element: <ApplySearchVehiclePage />,
          },
          {
            path: 'search-vin',
            element: <ApplySearchVinPage />,
          },
          {
            path: 'search-plate',
            element: <ApplySearchPlatePage />,
          },
          {
            path: 'search-year',
            element: <ApplySearchYearPage />,
          },
          {
            path: 'search-make',
            element: <ApplySearchMakePage />,
          },
          {
            path: 'search-model',
            element: <ApplySearchModelPage />,
          },
          {
            path: 'confirm-vehicle',
            element: <ApplyConfirmVehiclePage />,
          },
        ],
      },
      {
        path: 'applicant/:vehicleId',
        loader: ({ params }): Promise<Response | null> =>
          useApplicantStore.getState().loader(params),
        shouldRevalidate: ({ currentUrl, nextUrl }): boolean =>
          useDashboardStore.getState().computed.isVehicleEmpty ||
          currentUrl.pathname !== nextUrl.pathname,
        element: (
          <WorkflowGuard>
            <CmsGuard>
              <SessionGuard>
                <Outlet />
              </SessionGuard>
            </CmsGuard>
          </WorkflowGuard>
        ),
        children: [
          {
            index: true,
            element: <ApplicantPage />,
          },
          {
            path: 'residence-type',
            element: <ApplicantResidenceTypePage />,
          },
          {
            path: 'residence-details',
            element: <ApplicantResidenceDetailsPage />,
          },
          {
            path: 'residence-duration',
            element: <ApplicantResidenceDurationPage />,
          },
          {
            path: 'previous-residence',
            element: <ApplicantPreviousResidencePage />,
          },
          {
            path: 'employment-status',
            element: <ApplicantEmploymentStatusPage />,
          },
          {
            path: 'employment-type',
            element: <ApplicantEmploymentTypePage />,
          },
          {
            path: 'unemployment-type',
            element: <ApplicantUnemploymentTypePage />,
          },
          {
            path: 'employment-details',
            element: <ApplicantEmploymentDetailsPage />,
          },
          {
            path: 'unemployment-details',
            element: <ApplicantUnemploymentDetailsPage />,
          },
          {
            path: 'employment-duration',
            element: <ApplicantEmploymentDurationPage />,
          },
          {
            path: 'previous-employment',
            element: <ApplicantPreviousEmploymentPage />,
          },
          {
            path: 'additional-income',
            element: <ApplicantAdditionalIncomePage />,
          },
          {
            path: 'income-details',
            element: <ApplicantIncomeDetailsPage />,
          },
          {
            path: 'add-coapplicant',
            element: <ApplicantAddCoapplicantPage />,
          },
          {
            path: 'coapp-personal-relationship',
            element: <CoapplicantRelationshipPage />,
          },
          {
            path: 'coapp-personal-details',
            element: <CoapplicantPersonalDetailsPage />,
          },
          {
            path: 'coapp-residence-relationship',
            element: <CoapplicantResidenceRelationshipPage />,
          },
          {
            path: 'coapp-same-residence',
            element: <CoapplicantSameResidencePage />,
          },
          {
            path: 'coapp-different-residence-type',
            element: <CoapplicantDifferentResidenceTypePage />,
          },
          {
            path: 'coapp-different-residence',
            element: <CoapplicantDifferentResidencePage />,
          },
          {
            path: 'coapp-residence-duration',
            element: <CoapplicantResidenceDurationPage />,
          },
          {
            path: 'coapp-previous-residence',
            element: <CoapplicantPreviousResidencePage />,
          },
          {
            path: 'coapp-employment-status',
            loader: (): Promise<Response | null> =>
              useApplicantStore.getState().loadApplicant(),
            element: <CoapplicantEmploymentStatusPage />,
          },
          {
            path: 'coapp-employment-type',
            element: <CoapplicantEmploymentTypePage />,
          },
          {
            path: 'coapp-unemployment-type',
            element: <CoapplicantUnemploymentTypePage />,
          },
          {
            path: 'coapp-employment-details',
            element: <CoapplicantEmploymentDetailsPage />,
          },
          {
            path: 'coapp-unemployment-details',
            element: <CoapplicantUnemploymentDetailsPage />,
          },
          {
            path: 'coapp-employment-duration',
            element: <CoapplicantEmploymentDurationPage />,
          },
          {
            path: 'coapp-previous-employment',
            element: <CoapplicantPreviousEmploymentPage />,
          },
          {
            path: 'coapp-additional-income',
            element: <CoapplicantAdditionalIncomePage />,
          },
          {
            path: 'coapp-income-details',
            element: <CoapplicantIncomeDetailsPage />,
          },
          {
            path: 'edit-personal',
            element: <ApplicantEditPersonalPage />,
          },
          {
            path: 'coapp-edit-personal',
            element: <CoapplicantEditPersonalPage />,
          },
          {
            path: 'edit-residence',
            element: <ApplicantEditResidencePage />,
          },
          {
            path: 'coapp-edit-residence',
            element: <CoapplicantEditResidencePage />,
          },
          {
            path: 'edit-employment',
            element: <ApplicantEditEmploymentPage />,
          },
          {
            path: 'coapp-edit-employment',
            element: <CoapplicantEditEmploymentPage />,
          },
          {
            path: 'edit-income',
            element: <ApplicantEditIncomePage />,
          },
          {
            path: 'coapp-edit-income',
            element: <CoapplicantEditIncomePage />,
          },
          {
            path: 'review-applicant',
            element: <ApplicantReviewPage />,
          },
          {
            path: 'coapp-review-applicant',
            element: <CoapplicantReviewPage />,
          },
          {
            path: 'submit-application',
            element: <ApplicantSubmitPage />,
          },
          {
            path: 'application-success',
            element: <ApplicantSuccessPage />,
          },
        ],
      },
      {
        path: 'loan-documents',
        element: (
          <CmsGuard>
            <SessionGuard>
              <LoanDocumentGuard>
                <Outlet />
              </LoanDocumentGuard>
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <LoanDocumentPage />,
          },
          {
            path: 'list',
            element: <LoanDocumentListPage />,
          },
          {
            path: 'ric-upload',
            element: <LoanDocumentUploadRICPage />,
          },
          {
            path: 'vsc-upload',
            element: <LoanDocumentUploadVSCPage />,
          },
          {
            path: 'gap-upload',
            element: <LoanDocumentUploadGAPPage />,
          },
          {
            path: 'document-upload',
            element: <LoanDocumentUploadAllPage />,
          },
          {
            path: 'current-mileage',
            element: <LoanDocumentMileagePage />,
          },
          {
            path: 'success',
            element: <LoanDocumentSuccessPage />,
          },
        ],
      },
      {
        path: 'verifications/:vehicleId',
        loader: ({ params, request }): Promise<Response | null> =>
          useVerificationStore.getState().loader(params, request),
        shouldRevalidate: ({ currentUrl, nextUrl }): boolean =>
          useDashboardStore.getState().computed.isVehicleEmpty ||
          currentUrl.pathname !== nextUrl.pathname,
        element: (
          <CmsGuard>
            <SessionGuard>
              <Outlet />
            </SessionGuard>
          </CmsGuard>
        ),
        children: [
          {
            index: true,
            element: <VerificationPage />,
          },
          {
            path: 'document-list',
            element: <VerificationDocumentListPage />,
          },
          ...[
            'upload-license',
            'coapp-upload-license',
            'upload-insurance',
            'upload-registration',
            'upload-odometer',
            'upload-income',
            'coapp-upload-income',
            'upload-additional',
          ].map((path) => ({
            path: path,
            element: <VerificationUploadPage />,
          })),
        ],
      },
      {
        path: 'not-found',
        index: true,
        element: <NotFoundPage />,
      },
      {
        path: 'unified',
        children: [
          {
            index: true,
            element: <Navigate to="/sign-in" replace />,
          },
          {
            path: 'sign-in',
            children: [
              {
                index: true,
                element: <Navigate to="/sign-in" replace />,
              },
              {
                path: 'application-update',
                element: <Navigate to="/sign-in/application-update" replace />,
              },
            ],
          },
          {
            path: 'sign-up',
            element: <Navigate to="/sign-up" replace />,
          },
        ],
      },
      {
        path: '',
        element: <Navigate to="/sign-in" replace />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/not-found" replace />,
  },
];
